import { render, staticRenderFns } from "./myAppointDetail.vue?vue&type=template&id=613fc926&scoped=true&"
import script from "./myAppointDetail.vue?vue&type=script&lang=js&"
export * from "./myAppointDetail.vue?vue&type=script&lang=js&"
import style0 from "./myAppointDetail.vue?vue&type=style&index=0&id=613fc926&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613fc926",
  null
  
)

export default component.exports